import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import {
	Business as BusinessIcon,
	Refresh as RefreshIcon,
	WarningAmber as WarningAmberIcon,
} from '@mui/icons-material';

interface OrgMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onSwitchOrg: () => void;
  onRefreshMetadata: () => void;
  orgName: string;
  orgUsername: string;
	hasWarnings?: boolean;
	onViewWarnings?: () => void;
}

const OrgMenu: React.FC<OrgMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onSwitchOrg,
  onRefreshMetadata,
  orgName,
  orgUsername,
	hasWarnings,
	onViewWarnings,
}) => {
  const handleSwitchOrg = () => {
    onSwitchOrg();
    onClose();
  };

  const handleRefreshMetadata = () => {
    onRefreshMetadata();
    onClose();
  };

	const handleViewWarnings = () => {
		onViewWarnings?.();
		onClose();
	};

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      PaperProps={{ sx: { minWidth: 180 } }}
    >
      <MenuItem disabled>
        <ListItemText
          primary={orgName}
          secondary={orgUsername}
          slotProps={{ primary: { fontWeight: 'bold' } }}
        />
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleSwitchOrg}>
        <ListItemIcon>
          <BusinessIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Switch Org</ListItemText>
      </MenuItem>
      <MenuItem onClick={handleRefreshMetadata}>
        <ListItemIcon>
          <RefreshIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Refresh Metadata</ListItemText>
      </MenuItem>
			{hasWarnings && (
				<>
					<Divider />
					<MenuItem onClick={handleViewWarnings}>
						<ListItemIcon>
							<WarningAmberIcon fontSize="small" sx={{ color: 'warning.main' }} />
						</ListItemIcon>
						<ListItemText
							primary="Metadata Warnings"
							slotProps={{ primary: { color: 'warning.dark' } }}
						/>
					</MenuItem>
				</>
			)}
    </Menu>
  );
};

export default OrgMenu;
